export default __webpack_public_path__ + "static/media/construction.35d0dd52.svg";